import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=02e25cad"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02e25cad')) {
      api.createRecord('02e25cad', component.options)
    } else {
      api.reload('02e25cad', component.options)
    }
    module.hot.accept("./Desktop.vue?vue&type=template&id=02e25cad", function () {
      api.rerender('02e25cad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Desktop.vue"
export default component.exports